import { useState } from "react";
import { AlertTriangle, Boxes, ChevronRight, ClipboardList, FileSpreadsheet, FileText, Truck } from "lucide-react";
import { API, downloadBlob } from "../../lib/apiClient";

function rangeQuery(range) { const parts = []; if (range.start) parts.push(`start_date=${range.start}`); if (range.end) parts.push(`end_date=${range.end}`); return parts.length ? `&${parts.join("&")}` : ""; }

function ReportCard({ testid, icon, title, description, onExcel, onPdf, range, setRange }) {
  return <section className="panel report-card" data-testid={testid}>
    <div className="panel-heading"><div><h2>{title}</h2><p>{description}</p></div>{icon}</div>
    {range && <div className="report-range">
      <label>From<input type="date" data-testid={`${testid}-start-input`} value={range.value.start} onChange={(e) => setRange({ ...range.value, start: e.target.value })} /></label>
      <label>To<input type="date" data-testid={`${testid}-end-input`} value={range.value.end} onChange={(e) => setRange({ ...range.value, end: e.target.value })} /></label>
    </div>}
    <div className="report-actions">
      <button className="button ghost" data-testid={`${testid}-excel-button`} onClick={onExcel}><FileSpreadsheet size={15} /> Excel</button>
      <button className="button ghost" data-testid={`${testid}-pdf-button`} onClick={onPdf}><FileText size={15} /> PDF</button>
    </div>
  </section>;
}

export function ReportsView({ lowStock }) {
  const [txnRange, setTxnRange] = useState({ start: "", end: "" });
  const [challanRange, setChallanRange] = useState({ start: "", end: "" });
  const [showPlanList, setShowPlanList] = useState(false);
  const today = new Date().toISOString().slice(0, 10);

  return <div className="page-wrap"><div className="page-heading"><div><p className="eyebrow">Exports</p><h1>Reports</h1><p className="subheading">Download inventory and dispatch data for records or sharing.</p></div></div>
    <div className="report-grid">
      <ReportCard
        testid="report-inventory"
        icon={<Boxes size={20} className="muted-icon" />}
        title="Inventory stock levels"
        description="Current quantity, value and status of every item"
        onExcel={() => downloadBlob(`${API}/reports/inventory?format=excel`, "inventory_report.xlsx")}
        onPdf={() => downloadBlob(`${API}/reports/inventory?format=pdf`, "inventory_report.pdf")}
      />
      <ReportCard
        testid="report-transactions"
        icon={<ClipboardList size={20} className="muted-icon" />}
        title="Stock movement history"
        description="Every add, issue and adjustment in a date range"
        range={{ value: txnRange }}
        setRange={setTxnRange}
        onExcel={() => downloadBlob(`${API}/reports/transactions?format=excel${rangeQuery(txnRange)}`, `stock_movement_report_${today}.xlsx`)}
        onPdf={() => downloadBlob(`${API}/reports/transactions?format=pdf${rangeQuery(txnRange)}`, `stock_movement_report_${today}.pdf`)}
      />
      <ReportCard
        testid="report-challans"
        icon={<Truck size={20} className="muted-icon" />}
        title="Dispatch / challan history"
        description="Every delivery challan in a date range"
        range={{ value: challanRange }}
        setRange={setChallanRange}
        onExcel={() => downloadBlob(`${API}/reports/challans?format=excel${rangeQuery(challanRange)}`, `dispatch_report_${today}.xlsx`)}
        onPdf={() => downloadBlob(`${API}/reports/challans?format=pdf${rangeQuery(challanRange)}`, `dispatch_report_${today}.pdf`)}
      />
      <section className="panel report-card" data-testid="report-purchase-plan">
        <div className="panel-heading"><div><h2>Low-stock purchase plan</h2><p>Every item at or below its minimum level, ready to share with suppliers</p></div><AlertTriangle size={20} className="muted-icon" /></div>
        <button type="button" className="text-button" data-testid="report-purchase-plan-toggle-button" onClick={() => setShowPlanList(!showPlanList)}>{showPlanList ? "Hide list" : "View list"} ({lowStock.length}) <ChevronRight size={14} style={{ transform: showPlanList ? "rotate(90deg)" : "none" }} /></button>
        {showPlanList && <div className="purchase-plan-list" data-testid="purchase-plan-list">
          {lowStock.length === 0 ? <p className="import-hint">Nothing is below minimum level right now.</p> :
            lowStock.map((item) => <div className="purchase-plan-row" key={item.id}><b>{item.name}</b><span>{item.quantity} {item.unit} on hand · min {item.min_threshold} {item.unit}</span></div>)}
        </div>}
        <div className="report-actions">
          <button className="button ghost" data-testid="report-purchase-plan-excel-button" onClick={() => downloadBlob(`${API}/reports/purchase-plan?format=excel`, `purchase_plan_${today}.xlsx`)}><FileSpreadsheet size={15} /> Excel</button>
          <button className="button ghost" data-testid="report-purchase-plan-pdf-button" onClick={() => downloadBlob(`${API}/reports/purchase-plan?format=pdf`, `purchase_plan_${today}.pdf`)}><FileText size={15} /> PDF</button>
        </div>
      </section>
    </div>
  </div>;
}
